"use strict";

import Dom from "common/Dom";
import mixitup from "mixitup";
var config = {
  animation: {
    enable: false,
  },
};
var mixer = mixitup($(Dom.blogGrid), config);
export const sortBy = function sortBy(query) {
  mixer.sort(query);
};
